"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentType = void 0;
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["EMPLOYEE"] = "EMP";
    EmploymentType["SECOND"] = "SEC";
    EmploymentType["SELF"] = "SE";
    EmploymentType["RETIRED"] = "RET";
    EmploymentType["MILITARY"] = "MIL";
    EmploymentType["NOT_EMPLOYED"] = "NOT";
    EmploymentType["OTHER"] = "OTHER";
})(EmploymentType = exports.EmploymentType || (exports.EmploymentType = {}));
